import { AddCircleOutline, AutoAwesome, ImageOutlined, CloudUploadOutlined } from '@mui/icons-material';
import { Box, Button, Typography, useMediaQuery, useTheme, LinearProgress, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress } from '@mui/material';
import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { FormPaymentType, Modal, Search, ReturnSale, GenerarEtiquetas, CustomSnackbars, VariantsModal, CircularProgressCustom } from '../../components';
import { useMiContexto } from '../../components/base/ContextProvider';
import { useCurrentUser } from '../../components/base/UserProvider';
import Carrito from '../../components/carrito/Carrito';
import CarritoViewData from '../../components/carrito/CarritoViewData';
import { FormArticulo, FormStock, FormTabsArticulo } from '../../components/FormArticulo';
import FormVenta from '../../components/FormArticulo/FormVenta';
import FormPedidos from '../../components/pedidos/FormPedidos';
import Articles from '../../components/Table/Mobile/Articles';
import { FilterPanel } from '../../components';
import { OPERATION, STATUS_ORDER, STATUS_SALE, TYPE_MOVEMENT } from '../../helpers/enums';
import ArticuloService from '../../services/articulos';
import { useLocalStorage } from '../../services/localstorage';
import MovementsService from '../../services/movements';
import OrdersService from '../../services/orders';
import SaleService from '../../services/sales';
import PaymentTypesService from '../../services/paymentTypes';
import UserService from '../../services/user';
import StoreService from '../../services/stores';
import EtiquetasService from '../../services/etiquetas';
import CategoriaService from '../../services/categorias';
import StockMovement from '../../components/Table/Mobile/StockMovement';
import RecategorizarDialog from '../../components/FormArticulo/RecategorizarDialog';
import UploadImage from '../../components/UploadImage';
import ImagenesService from '../../services/imagenes';
import ImagenesAIService from '../../services/imagenesAI';
import { IMAGES_HOST } from '../../config/config';
import { distributeLineAmounts } from '../../helpers/payments';

const Articulos = ({ store, setOptions, setChildHeader }) => {
  // const refAImprimir = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { miValor } = useMiContexto();
  const { isAdmin } = useCurrentUser();

  const [investment, setInvestment] = useState(0);
  const [thereAreInvestment, setThereAreInvestment] = useState(true);
  const [loadsArticulos, setLoadsArticulos] = useState(true);
  const [loadingArticulos, setLoadingArticulos] = useState(false);
  const loadingArticulosRef = useRef(false); // guard contra cargas concurrentes
  const [saving, setSaving] = useState(false);
  const [articulos, setArticulos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [articleSelected, setArticleSelected] = useState(null);
  const [addStock, setAddStock] = useState('');
  const [articleInCart, setArticleInCart] = useLocalStorage('articlesInCart', []);
  const [viewCart, setViewCart] = useState(false);
  const [loadingCart, setLoadingCart] = useState(false);
  const [onlyWithStock, setOnlyWithStock] = useState(true);
  const [creating, setCreating] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([])
  const [loadingStockMovements, setLoadingStockMovements] = useState(false);
  const [loadingMoreStockMovements, setLoadingMoreStockMovements] = useState(false);
  const [stockMovements, setStockMovements] = useState([]);
  const [stockMovementsPage, setStockMovementsPage] = useState(1);
  const [stockMovementsHasMore, setStockMovementsHasMore] = useState(false);
  const [dataSale, setDataSale] = useState({});
  const [saleReturned, setSaleReturned] = useState(null);
  const [etiquetastoPrint, setEtiqueteToPrint] = useLocalStorage('etiquetasToPrint', []);
  const [categories, setCategories] = useState([]);
  const [rangePrices, setRangePrices] = useState({ minPrice: Infinity, maxPrice: -Infinity });
  const [filterValues, setFilterValues] = useState({ name: '', category: '', rangePrices: [rangePrices?.minPrice, rangePrices?.maxPrice] });
  const [messageSnackbar, setMessageSnackbar] = useState('');
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [openVariantsModal, setOpenVariantsModal] = useState(false);
  const [articleUpdate, setArticleUpdate] = useState(null);
  const [articleForVariants, setArticleForVariants] = useState(null);
  const [recategorizarDialog, setRecategorizarDialog] = useState({ open: false, article: null });
  const [updateImageDialog, setUpdateImageDialog] = useState({ open: false, article: null });
  const [updateImageFiles, setUpdateImageFiles] = useState([]);
  const [updateImagePreviews, setUpdateImagePreviews] = useState([]);
  const [updateImagePrompt, setUpdateImagePrompt] = useState('');
  const [updatingImage, setUpdatingImage] = useState(false);

  const loadCategories = async () => {
    var resp = await CategoriaService.getAll()
    setCategories(resp)
  }

  const mapPaymentTypesToForm = (items = []) =>
    (items || []).map((pt) => ({
      _id: pt?._id,
      name: pt?.name || 'Medio de pago',
      description: pt?.description || '',
      applies_surcharge: Boolean(pt?.applies_surcharge),
      installments: Array.isArray(pt?.installments) ? pt.installments : [],
      amount: 0,
    }));

  const getPaymentTypesForForm = () => structuredClone(paymentTypes);

  const loadArticulos = async () => {
    // Evita cargas concurrentes si ya hay una en vuelo (e.g.: miValor y loadsArticulos cambian juntos)
    if (loadingArticulosRef.current) return;
    loadingArticulosRef.current = true;
    setLoadingArticulos(true)
    var resp = await ArticuloService.getAllArticlesInStoreTo(store._id, OPERATION.VENDER, onlyWithStock, 1)
    if (!resp || (resp && resp.length === 0))
      setArticleInCart([])
    if (resp)
      setArticulos(resp); // reemplaza la lista en lugar de concatenar (evita duplicados por stale closure)

    const range = resp?.reduce(
      (acc, item) => ({
        minPrice: Math.min(acc.minPrice, item.prices.sale_price),
        maxPrice: Math.max(acc.maxPrice, item.prices.sale_price),
      }),
      { minPrice: Infinity, maxPrice: -Infinity }
    );
    setRangePrices(range)
    setFilterValues({ name: '', category: '', rangePrices: [range?.minPrice, range?.maxPrice] })
    setLoadsArticulos(false)
    setLoadingArticulos(false)
    loadingArticulosRef.current = false;
  }

  const loadArticulos2 = async (page) => {
    console.log("cargaaa")
    return await ArticuloService.searchArticlesInStore(store._id, searchQuery, OPERATION.VENDER, onlyWithStock, page)
    // if (resp.length > 0)
    //   setArticulos((prevArticulos) => [...prevArticulos, ...resp]);
    //setPage(page + 1)
  }

  const loadUsers = async () => {
    var resp = await UserService.getAll()
    var respFiltered = resp.filter(u => u.name !== '' && u.name !== 'Diego Cesar')
    setUsers(respFiltered)
  }

  useEffect(() => {
    if (users.length === 0) {
      loadUsers()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!store?._id) return;
    const controller = new AbortController();

    const loadPaymentTypes = async () => {
      try {
        const response = await PaymentTypesService.listByStore(store._id, { signal: controller.signal });
        if (controller.signal.aborted) return;
        setPaymentTypes(mapPaymentTypesToForm(Array.isArray(response) ? response : []));
      } catch (err) {
        if (err?.name === 'CanceledError' || err?.name === 'AbortError') return;
        console.error('Error loading payment types:', err);
        setPaymentTypes([]);
      }
    };

    loadPaymentTypes();
    return () => controller.abort();
  }, [store?._id]);

  useEffect(() => {
    if (!store?._id) return;

    const unsubscribe = PaymentTypesService.subscribeToChanges(async ({ storeId }) => {
      if (storeId && storeId !== store._id) return;
      try {
        const response = await PaymentTypesService.listByStore(store._id, { forceRefresh: true });
        setPaymentTypes(mapPaymentTypesToForm(Array.isArray(response) ? response : []));
      } catch (err) {
        console.error('Error refreshing payment types:', err);
      }
    });

    return () => unsubscribe();
  }, [store?._id]);

  useEffect(() => {
    if (loadsArticulos && miValor) {
      loadCategories()
      getMovementsDineroDisponible()
      loadArticulos()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadsArticulos, miValor])

  const saveArticulo = async (data) => {
    setSaving(true)
    data.store_id = store._id
    if (data) {
      var artSaved = await ArticuloService.saveArticleInStore(store._id, data)
      const productos = Array(artSaved.quantity)
        .fill(null)
        .map(() => ({ ...artSaved }));
      setEtiqueteToPrint(etiquetastoPrint.concat(productos))
      setLoadsArticulos(true)
    }
    setSaving(false)
    setOpenModal(false)
  }

  const addToCart = async (data) => {
    addToCart2(data, articleSelected)
    setOpenModalEdit(false)
  }

  const addToCart2 = async (data, a) => {
    data.store_id = store._id
    data.article_id = a.article_id
    data.sku = a.sku
    data.quantity_in_stock = a.quantity - data.quantity_sold
    data.name = a.article?.name
    data.description = a.article?.description
    data.image = a.article?.images && a.article?.images[0]
    
    // Agregar información de descuento a la descripción si existe
    if (data.discount_applied) {
      const discountText = data.discount_applied.discount_percentage 
        ? `${data.discount_applied.discount_percentage}% OFF`
        : `$${data.discount_applied.discount_amount} OFF`;
      data.discount_description = `🏷️ ${data.discount_applied.offer_name} (${discountText})`;
    }
    
    if (data) {
      if (thereAreStock(a)) {
        if (!articleIsInCart(data)) {
          setArticleInCart([...articleInCart, { ...data }]);
        } else {
          var newArticleInCart = articleInCart.map(a => {
            var newArt = { ...a }
            if (a.article_id === data.article_id && a.prices_sold.sale_price === data.prices_sold.sale_price) {
              newArt.quantity_in_stock = data.quantity_in_stock
              newArt.quantity_sold += data.quantity_sold
            }
            return newArt;
          })
          setArticleInCart(newArticleInCart)
        }
      }
    }
    a.quantity = a.quantity - data.quantity_sold
    //setSaving(false)
    console.log("fin add cart")
    setOpenModalEdit(false)
  }

  const saveStock = async (data) => {
    setSaving(true)
    data.article_id = articleSelected.article_id
    if (data) {
      await ArticuloService.updateArticleInStore(data)
      if (data.stock_new) {
        for (let index = 0; index < data.stock_new.length; index++) {
          const productos = Array(data.stock_new[index].quantity)
            .fill(null)
            .map(() => ({ 
              ...articleSelected,
              prices: { 
                ...articleSelected.prices,
                list_price: data.prices.list_price,
                sale_price: data.prices.sale_price
              } 
            }));
          setEtiqueteToPrint(etiquetastoPrint.concat(productos))
        }
      }
      setLoadsArticulos(true)
    }
    setSaving(false)
    setOpenModalEdit(false)
  }

  const optionSelected = (option, article) => {
    console.log(option, article);
    setArticleSelected(article);
    
    if (option?.id === 'variants') {
      setArticleForVariants(article);
      setOpenVariantsModal(true);
    } else if (option?.id === 'recategorizar') {
      setRecategorizarDialog({ open: true, article });
    } else if (option?.id === 'updateImage') {
      setUpdateImageFiles([]);
      setUpdateImagePreviews([]);
      setUpdateImagePrompt('');
      setUpdateImageDialog({ open: true, article });
    } else {
      setAddStock(option?.id);
      getStockMovements(article.article._id, { page: 1, append: false });
      if (option?.id !== 'edit') {
        setOpenModalEdit(true);
      }
    }
  }

  // Función para calcular la mejor oferta de un artículo
  const getBestOffer = (article) => {
    if (!article.applicable_offers || article.applicable_offers.length === 0) return null;
    
    // Ordenar por prioridad (mayor primero) y tomar la primera
    const sortedOffers = [...article.applicable_offers].sort((a, b) => b.priority - a.priority);
    const bestOffer = sortedOffers[0];
    
    const price = article?.prices?.sale_price || 0;
    
    // Calcular precio final
    let finalPrice = price;
    let discountAmount = 0;
    
    if (bestOffer.type === 'percentage' && bestOffer.discount_percentage) {
      discountAmount = (price * bestOffer.discount_percentage) / 100;
      finalPrice = price - discountAmount;
    } else if (bestOffer.type === 'fixed_amount' && bestOffer.discount_amount) {
      discountAmount = bestOffer.discount_amount;
      finalPrice = price - discountAmount;
    }
    
    return {
      ...bestOffer,
      final_price: Math.max(0, finalPrice),
      discount_amount: discountAmount
    };
  };

  const handleAddToCart = (article) => {
    // Calcular mejor oferta si tiene applicable_offers
    const bestOffer = getBestOffer(article);
    
    // Calcular precio con descuento si hay oferta aplicada (puede venir del enriquecimiento o calcularse aquí)
    const salePrice = article.discount_price || (bestOffer ? bestOffer.final_price : article?.prices?.sale_price);
    const originalPrice = article.original_price || article?.prices?.sale_price;
    
    // Usar la oferta aplicada si viene enriquecida, sino usar la calculada
    const offerToApply = article.applied_offer || bestOffer;
    
    var data = {
      quantity_in_stock: article.quantity,
      quantity_sold: 1,
      prices_sold: {
        list_price: article?.prices?.list_price,
        sale_price: salePrice
      },
      prices: {
        list_price: article?.prices?.list_price,
        sale_price: article?.prices?.sale_price
      },
      original_price: originalPrice,
      discount_applied: offerToApply ? {
        offer_id: offerToApply._id || offerToApply.id,
        offer_name: offerToApply.name,
        discount_type: offerToApply.type,
        discount_percentage: offerToApply.discount_percentage,
        discount_amount: offerToApply.discount_amount
      } : null
    }
    addToCart2(data, article)
  }

  const thereAreStock = (article) => article.quantity > 0;

  const articleIsInCart = (articleSold) => articleInCart.some(art => art.article_id === articleSold.article_id &&
    art.prices_sold.sale_price === articleSold.prices_sold.sale_price);

  const handleOpenCart = useCallback(() => {
    setViewCart(prev => !prev);
    setLoadingCart(prev => !prev);
  }, []);

  const articleInCartQuantity = articleInCart?.reduce((sum, item) => {
    return sum + item.quantity_sold;
  }, 0);

  const handleRemoveItemFromCart = (article) => {
    var newArticleInCart = articleInCart.filter(a => a.article_id !== article.article_id ||
      (a.article_id === article.article_id && a.prices_sold.sale_price !== article.prices_sold.sale_price))
    var art = articulos.find(a => a.article_id === article.article_id)
    if (art) {
      art.quantity = art.quantity + article.quantity_sold
      updateStockArticle(art)
    }
    setArticleInCart(newArticleInCart);
  }

  const updateStockArticle = (newArticle) => {
    setArticulos(prevItems =>
      prevItems.map(item =>
        item.id === newArticle.article_id ? newArticle : item
      )
    );
  };

  const handleSell = async ({ name, delivery, vendor, deposit }) => {
    if (delivery) {
      if (!paymentTypes.length) {
        setMessageSnackbar('No hay medios de pago configurados para esta tienda.');
        setShowSnackbar(true);
        return;
      }
      setOpenModalEdit(true)
      setSaving(true)
      setAddStock('confirmSale')
      setDataSale({
        status: delivery ? STATUS_SALE.FINISHED : STATUS_SALE.RESERVED,
        nameSale: name,
        userId: vendor,
        deposit: deposit
      })
    } else {
      var data = articleInCart.map((a) => ({
        ...a,
        quantity_in_stock: a.quantity_in_stock + a.quantity_sold,
        status: delivery ? STATUS_SALE.FINISHED : STATUS_SALE.RESERVED,
        nameSale: name,
        userId: vendor,
        deposit: deposit
      }))
      setSaving(true)
      setViewCart(false)
      setArticulos([])
      await SaleService.save(store._id, data)
      setLoadsArticulos(true)
      setArticleInCart([])
      setSaving(false)
    }
  }

  const handleFinishSell = async ({ payments }) => {
    setOpenModalEdit(false)
    articleInCart.forEach(sale => {
      if (!sale.payments) {
        sale.payments = []
      }
      var payment = payments.find(p => !p.saleIds || p.saleIds.includes(sale._id))
      sale.payments = distributeLineAmounts(payment.paymenttypes, sale.prices_sold.sale_price, sale.quantity_sold)
    })

    // A vale is a discount on the sale total, applied once on the first matched sale of its group.
    payments.forEach((payment) => {
      if (!payment.credit?.code || !payment.credit?.amount) return
      const matchedSale = articleInCart.find(sale => !payment.saleIds || payment.saleIds.includes(sale._id))
      if (matchedSale) {
        matchedSale.store_credit_applied = { code: payment.credit.code, amount: payment.credit.amount }
      }
    })

    if (articleInCart) {
      var data = articleInCart.map((a) => ({
        ...a,
        ...dataSale,
        quantity_in_stock: a.quantity_in_stock + a.quantity_sold,
      }))
      setViewCart(false)
      setArticulos([])
      await SaleService.save(store._id, data)
      setLoadsArticulos(true)
      setArticleInCart([])
      setSaving(false)
    }
  }

  const getMovementsDineroDisponible = async () => {
    if (store) {
      var resp = await MovementsService.searchMovements(store._id, `type=${TYPE_MOVEMENT.DINERO_DISPONIBLE}`)
      var aux = resp?.length > 0 && resp[0].amount > 0
      resp && setInvestment(resp[0].amount)
      setThereAreInvestment(aux)
    }
  }

  // Memorizar el handler de búsqueda
  // NO se hace la llamada a la API aquí: el resultado iría a `articulos` (estado del padre)
  // pero Articles.jsx maneja su propio estado interno y nunca usa ese valor.
  // Al actualizar searchQuery, el key del componente <Articles> cambia, lo que fuerza
  // su re-mount y su propio fetchItems(page=1) — así se dispara UN solo request.
  const onSearchHandlerCallback = useCallback(({ searchQuery }, onlyStock = false) => {
    setOnlyWithStock(onlyStock);
    setSearchQuery(searchQuery);
    setLoadsArticulos(false);
  }, []);

  // Memorizar el componente del header
  const headerContent = useMemo(() => (
    <Box display='flex' flexDirection='row' width={'100%'}>
      <Search onSearch={onSearchHandlerCallback} />
      <Carrito length={articleInCartQuantity} openCart={handleOpenCart} />
    </Box>
  ), [articleInCartQuantity, onSearchHandlerCallback, handleOpenCart]);

  useEffect(() => {
    setOptions && setOptions([{
      id: 'addArticle', Icon: () =>
        <Button size='small' onClick={() => { setCreating(false); setOpenModal(true) }} startIcon={<AddCircleOutline />}>
          Nuevo Articulo
        </Button>
    },
    {
      id: 'createArticle', Icon: () =>
        <Button size='small' onClick={() => { setCreating(true); setOpenModal(true) }} startIcon={<AddCircleOutline />}>
          Crear Articulo
        </Button>
    }])
    setChildHeader && setChildHeader(headerContent)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerContent])

  const handleSubmitOrder = async (data) => {
    setSaving(true)
    // data may contain lines from enhanced FormPedidos
    const { lines } = data;
    const mappedLines = (lines && lines.length ? lines : data.lines || []).map(l => ({
      note: l.note,
      requested_qty: Number(l.requestedQty ?? l.requested_qty ?? 0),
      obtained_qty: Number(l.obtainedQty ?? l.obtained_qty ?? 0),
      done: !!l.done
    }));
    const request = {
      ...data,
      article_id: articleSelected.article_id,
      store_id: articleSelected.store_id,
      prices: articleSelected.prices,
      status: STATUS_ORDER.OPENED,
      lines: mappedLines
    };
    if (!request.description && request.lines && request.lines.length) {
      request.description = request.lines.map(l => `${l.requestedQty || 1} ${l.note}`).join(', ');
    }
    try {
      await OrdersService.save(store._id, request)
      setLoadsArticulos(true)
    } finally {
      setSaving(false)
      setOpenModalEdit(false)
    }
  }

  const handleCheckBox = (event, value) => {
    setOnlyWithStock(event.target.checked)
    onSearchHandlerCallback({ searchQuery: '' }, event.target.checked)
  }

  const isEdit = addStock === 'edit'

  const getStockMovements = async (articleId, options = {}) => {
    const { page = 1, append = false } = options

    if (append) {
      setLoadingMoreStockMovements(true)
    } else {
      setLoadingStockMovements(true)
    }

    try {
      const resp = await StoreService.searchStockMovementsPaginated(store._id, `articleId=${articleId}&page=${page}&limit=50`)
      const items = resp?.items || []
      setStockMovements((prev) => (append ? prev.concat(items) : items))
      setStockMovementsPage(page)
      setStockMovementsHasMore(Boolean(resp?.hasMore))
    } finally {
      if (append) {
        setLoadingMoreStockMovements(false)
      } else {
        setLoadingStockMovements(false)
      }
    }
  }

  const handleLoadMoreStockMovements = async () => {
    const articleId = articleSelected?.article?._id || articleSelected?.article_id
    if (!articleId || loadingMoreStockMovements || !stockMovementsHasMore) {
      return
    }
    await getStockMovements(articleId, { page: stockMovementsPage + 1, append: true })
  }

  const handleSubmitReturn = async compra => {
    console.log(saleReturned)
    setSaving(true)
    await SaleService.returnSale(saleReturned)
    setSaving(false)
    setOpenModalEdit(false)
    setLoadsArticulos(true)
  }

  const descargarEtiquetas = async () => {
    try {
      const response = await EtiquetasService.generate(etiquetastoPrint);

      console.log(response.data);

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "etiquetas.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      setMessageSnackbar('PDF con etiqutas generado')
      setShowSnackbar(true)
      setEtiqueteToPrint([])
    } catch (err) {
      alert("Hubo un problema al descargar el archivo");
      console.error(err);
    }
  };

  const handleVariantsSuccess = (responseData) => {
    const articleId = articleForVariants?.article_id;
    // type_detail puede venir directo en la respuesta o dentro de un objeto
    const newTypeDetail = responseData?.type_detail || (Array.isArray(responseData) ? responseData : null);

    if (articleId) {
      // Actualizar estado interno de Articulos.jsx
      setArticulos((prev) =>
        prev.map((art) =>
          art.article_id === articleId
            ? { ...art, ...(newTypeDetail ? { type_detail: newTypeDetail } : {}) }
            : art
        )
      );
      // Notificar a Articles.jsx para que actualice su vista
      setArticleUpdate({ articleId, changes: { type_detail: newTypeDetail || [] }, ts: Date.now() });
    }
    setMessageSnackbar('Variantes actualizadas exitosamente');
    setShowSnackbar(true);
    // Forzar re-fetch completo para persistir correctamente el cambio en la lista
    setLoadsArticulos(true);
  };

  const handleCloseVariantsModal = () => {
    setOpenVariantsModal(false);
    setArticleForVariants(null);
  };

  const handleApplyFilters = async ({ name, category, rangePrices }) => {
    setLoadingArticulos(true)
    const params = new URLSearchParams({
      name: name,
      to: OPERATION.VENDER,
      onlyStock: false,
      category: category,
      // rangePrices: rangePrices
    })
    setSearchQuery(params)
    var resp = await ArticuloService.searchArticlesInStore2(store._id, params)
    console.log(resp)
    setArticulos(resp)
    setLoadsArticulos(false);
    setLoadingArticulos(false)
  }

  const handleConfirmGeneracionEtiquetas = quantity => {
    const productos = Array(quantity)
      .fill(null)
      .map(() => ({ ...articleSelected }));
    setEtiqueteToPrint(etiquetastoPrint.concat(productos))
    setOpenModalEdit(false)
  }

  return (<>
    {/* <div style={{ minHeight: '100vh', height:'100%', display: 'flex', flexDirection: 'column', background: 'green' }}> */}
    {(loadingArticulos || saving) && <CircularProgressCustom size={350} />}
    <Box display='flex' flexDirection={!isMobile ? 'row' : 'column'} height="100vh">
      <Box display='flex' flexDirection='row' flexWrap="wrap" flex='1' overflow="auto">
        {viewCart && <CarritoViewData users={users} rows={articleInCart} onRemoveItem={handleRemoveItemFromCart} onCancel={() => setViewCart(false)} onSell={handleSell} />}
        {!viewCart && !loadingArticulos && articulos && !openModal && !isEdit &&
          <Articles
            key={`articles-${searchQuery}-${onlyWithStock}`}
            options={[
              { name: 'Editar', id: 'edit', adminOnly: true },
              { name: 'Pedido', id: 'order', adminOnly: true },
              { name: 'Vender', id: 'sale', adminOnly: true },
              { name: 'Agregar stock', id: 'addstock', adminOnly: true },
              { name: 'Historial', id: 'historial' },
              { name: 'Generar etiqueta', id: 'printEtiq', adminOnly: true },
              { name: 'Variantes', id: 'variants', adminOnly: true },
              { name: 'Recategorizar', id: 'recategorizar', adminOnly: true },
              { name: 'Actualizar imagen', id: 'updateImage' },
            ].filter(o => !o.adminOnly || isAdmin)}
            optionSelected={optionSelected}
            addToCart={handleAddToCart}
            fetchArticles={loadArticulos2}
            loadLizy
            externalUpdate={articleUpdate}
          />
        }
      </Box>
      <Box display='flex' flexDirection={!openModal && !isEdit ? 'column' : 'row'} width={isMobile ? '100%' : "310px"} overflow="auto" sx={{ flexShrink: 0 }}>
        <Box display='flex' flexDirection={'column'}>
          {!loadingArticulos && !openModal && !isEdit && <Box display='flex' flexDirection='column' alignItems='stretch'>
            <Box display='flex' flexDirection='row' alignItems='center'>
              <Checkbox checked={onlyWithStock} onChange={handleCheckBox} />
              <Typography>Solamente con Stock disponible</Typography>
            </Box>
            <Button onClick={descargarEtiquetas} disabled={etiquetastoPrint.length <= 0}>{`Descargar ${etiquetastoPrint.length} etiquetas`}</Button>
          </Box>}
          {!isMobile && <FilterPanel
            //open={true}
            // toggleDrawer={toggleDrawer}
            loading={loadingArticulos}
            isDrawer={false}
            categories={categories}
            filterValues={filterValues}
            onClear={() => setFilterValues({ name: '', category: '', rangePrices: [rangePrices.minPrice, rangePrices.maxPrice] })}
            onApply={({ name, category, rangePrices } )=> handleApplyFilters({ name, category, rangePrices })}
          />}
        </Box>
        {!isMobile && <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          Content={() => thereAreInvestment ? <FormArticulo storeId={store._id} createArticle={creating} articleData={{ investment: investment }} investmentAmount={investment} onClose={() => setOpenModal(false)} onSubmit={saveArticulo} saving={saving} /> : 'No hay inversion'}
          buttonClose={!thereAreInvestment}
        />}
        {isMobile && (openModal || isEdit) && !saving &&
          <FormTabsArticulo
            createArticle={creating}
            articleData={articleSelected}
            onSubmit={saveArticulo}
            investmentAmount={investment}
            onCancel={() => { setAddStock(''); setOpenModal(false); setArticleSelected(null) }}
            saving={saving}
            articles={articulos}
            storeId={store._id}
          />
        }
        <Modal
          open={openModalEdit}
          onClose={() => setOpenModalEdit(false)}
          Content={() => addStock === 'sale' ?
            <FormVenta article={articleSelected} onClose={() => setOpenModalEdit(false)} onSubmit={addToCart} saving={saving} /> :
            addStock === 'addstock' ?
              <FormStock article={articleSelected} onClose={() => setOpenModalEdit(false)} onSubmit={saveStock} store={store} saving={saving} /> :
              addStock === 'order' ?
                <FormPedidos article={articleSelected} onClose={() => setOpenModalEdit(false)} onSubmit={handleSubmitOrder} /> :
                addStock === 'historial' ?
                  <Box display='flex' flexDirection='column' gap={1}>
                    <StockMovement loading={loadingStockMovements} compras={stockMovements} isHistorial onReturn={(sale) => { setAddStock('returnSale'); setSaleReturned(sale); setOpenModalEdit(true) }} />
                    {stockMovementsHasMore && (
                      <Box display='flex' justifyContent='center'>
                        <Button
                          variant='outlined'
                          onClick={handleLoadMoreStockMovements}
                          disabled={loadingMoreStockMovements}
                        >
                          {loadingMoreStockMovements ? 'Cargando...' : 'Cargar más'}
                        </Button>
                      </Box>
                    )}
                  </Box> :
                  addStock === 'confirmSale' ?
                    <FormPaymentType onClose={() => setOpenModalEdit(false)} onSubmit={handleFinishSell} storeId={store._id} payments={[{
                      nameSale: '',
                      paymenttypes: getPaymentTypesForForm(),
                      total: articleInCart.reduce((sum, art) => sum + (art.quantity_sold * art.prices_sold.sale_price), 0),
                      amount: 0
                    }]} /> :
                    addStock === 'returnSale' ?
                      <ReturnSale sale={saleReturned} onSubmitReturnSale={handleSubmitReturn} onCancel={() => { setSaleReturned(null); setOpenModalEdit(false) }} /> :
                      addStock === 'printEtiq' ?
                        <GenerarEtiquetas onClose={() => setOpenModalEdit(false)} onConfirm={handleConfirmGeneracionEtiquetas} /> :
                        <></>
          }
          buttonClose={addStock === 'historial'}
        />
      </Box>
    </Box>
    <CustomSnackbars show={showSnackbar} onClose={() => setShowSnackbar(false)} message={messageSnackbar}/>
    <VariantsModal
      open={openVariantsModal}
      onClose={handleCloseVariantsModal}
      article={articleForVariants}
      storeId={store._id}
      onSuccess={handleVariantsSuccess}
    />
    <RecategorizarDialog
      open={recategorizarDialog.open}
      onClose={() => setRecategorizarDialog({ open: false, article: null })}
      article={recategorizarDialog.article}
      storeId={store._id}
      onSuccess={() => setRecategorizarDialog({ open: false, article: null })}
    />
    <Dialog open={updateImageDialog.open} onClose={() => !updatingImage && setUpdateImageDialog({ open: false, article: null })} maxWidth='sm' fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}>
      {/* Header */}
      <Box sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', px: 2.5, pt: 2.2, pb: 1.8 }}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Box display='flex' alignItems='center' gap={1}>
            <ImageOutlined sx={{ color: 'white', fontSize: 22 }} />
            <Typography sx={{ color: 'white', fontWeight: 800, fontSize: '1rem' }}>Actualizar imagen</Typography>
          </Box>
          {updateImageDialog.article && (
            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.75rem', fontWeight: 500 }}>
              {updateImageDialog.article.article?.name}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Loading overlay */}
      {updatingImage && (
        <Box sx={{
          position: 'absolute', inset: 0, zIndex: 10,
          bgcolor: 'rgba(255,255,255,0.92)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2,
          backdropFilter: 'blur(4px)',
        }}>
          <CircularProgress size={52} thickness={4} sx={{ color: '#764ba2' }} />
          <Typography sx={{ fontWeight: 800, fontSize: '1.1rem', color: '#764ba2', letterSpacing: 0.5 }}>
            {updateImagePrompt.trim() ? '✨ Generando imagen con IA...' : '☁️ Subiendo imagen...'}
          </Typography>
          <Typography sx={{ fontSize: '0.78rem', color: '#999' }}>Espere por favor, esto puede tardar unos segundos</Typography>
        </Box>
      )}

      <DialogContent sx={{ pt: 2, pb: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Upload zone */}
        <Box>
          <Typography variant='caption' sx={{ fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5 }}>Imagen</Typography>
          <label htmlFor='update-image-input' style={{ display: 'block', marginTop: 6 }}>
            <Box sx={{
              border: '2px dashed', borderColor: updateImageFiles.length ? '#764ba2' : '#ddd',
              borderRadius: 2.5, p: 2, cursor: 'pointer', textAlign: 'center',
              bgcolor: updateImageFiles.length ? '#f5f0ff' : '#fafafa',
              transition: 'all 0.2s',
              '&:hover': { borderColor: '#764ba2', bgcolor: '#f5f0ff' },
            }}>
              {updateImagePreviews.length === 0 ? (
                <Box display='flex' flexDirection='column' alignItems='center' gap={0.5}>
                  <CloudUploadOutlined sx={{ fontSize: 36, color: '#bbb' }} />
                  <Typography sx={{ fontSize: '0.82rem', color: '#999' }}>Tocá para seleccionar imagen</Typography>
                </Box>
              ) : (
                <Box display='flex' flexWrap='wrap' gap={1} justifyContent='center'>
                  {updateImagePreviews.map((src, i) => (
                    <Box key={i} component='img' src={src} alt={`preview-${i}`}
                      sx={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </label>
          <input
            id='update-image-input'
            type='file'
            accept='image/*'
            multiple
            style={{ display: 'none' }}
            onChange={(e) => {
              const files = Array.from(e.target.files);
              setUpdateImageFiles(files);
              setUpdateImagePreviews(files.map(f => URL.createObjectURL(f)));
            }}
          />
        </Box>

        {/* AI prompt */}
        <Box>
          <Box display='flex' alignItems='center' gap={0.5} mb={0.75}>
            <AutoAwesome sx={{ fontSize: 14, color: '#764ba2' }} />
            <Typography variant='caption' sx={{ fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: 0.5 }}>Prompt IA <Typography component='span' variant='caption' sx={{ color: '#aaa', textTransform: 'none', fontWeight: 400 }}>(opcional — reemplaza la imagen cargada)</Typography></Typography>
          </Box>
          <TextField
            size='small'
            fullWidth
            multiline
            minRows={2}
            maxRows={5}
            placeholder='Ej: chaleco de jean azul sobre fondo blanco, estilo foto de producto...'
            value={updateImagePrompt}
            onChange={(e) => setUpdateImagePrompt(e.target.value)}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 2.5, pb: 2, gap: 1 }}>
        <Button onClick={() => setUpdateImageDialog({ open: false, article: null })} disabled={updatingImage} sx={{ borderRadius: 2 }}>Cancelar</Button>
        <Button
          variant='contained'
          disabled={updatingImage || (updateImageFiles.length === 0 && !updateImagePrompt.trim())}
          onClick={async () => {
            try {
              setUpdatingImage(true);
              const fd = new FormData();
              updateImageFiles.forEach(f => fd.append('image', f));
              let uploaded;
              if (updateImagePrompt.trim()) {
                fd.append('prompt', updateImagePrompt.trim());
                uploaded = await ImagenesAIService.generate(fd);
                uploaded = uploaded.map(imag => `${IMAGES_HOST}/${imag}.jpg`)
              } else {
                uploaded = await ImagenesService.upload(fd);
              }
              await ArticuloService.updateImages(store._id, updateImageDialog.article._id, uploaded);
              setLoadsArticulos(true);
              setMessageSnackbar('Imagen actualizada');
              setShowSnackbar(true);
              setUpdateImageDialog({ open: false, article: null });
            } catch (err) {
              console.error(err);
              setMessageSnackbar('Error al actualizar imagen');
              setShowSnackbar(true);
            } finally {
              setUpdatingImage(false);
            }
          }}
          sx={{ borderRadius: 2, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', '&:hover': { filter: 'brightness(0.9)' } }}
        >
          {updateImagePrompt.trim() ? <><AutoAwesome sx={{ fontSize: 16, mr: 0.5 }} />Generar con IA</> : <><CloudUploadOutlined sx={{ fontSize: 16, mr: 0.5 }} />Guardar imagen</>}
        </Button>
      </DialogActions>
    </Dialog>
  </>);
}

export default Articulos;
